import {
  ModalDialog,
  ModalDialogHeader,
  ModalDialogTitle,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogActions,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'

export interface CompleteInfoGatheringEarlyConfirmationDialogProps {
  /**
   * Whether the dialog is open.
   */
  isOpen: boolean
  /**
   * Callback when the dialog should close.
   */
  onClose?: () => unknown
  /**
   * Callback when the confirm button is pressed.
   */
  onConfirm?: () => unknown
  /**
   * Whether the confirm operation is pending.
   */
  isPending?: boolean
  /**
   * Test ID attribute.
   */
  testId?: string
  /**
   * Test ID attribute for the confirm button.
   */
  confirmTestId?: string
  /**
   * Test ID attribute for the close button.
   */
  closeTestId?: string
}

/**
 * Dialog for confirming whether the user wants to complete info
 * gathering early.
 */
export function CompleteInfoGatheringEarlyConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  isPending,
  testId,
  confirmTestId,
  closeTestId,
}: CompleteInfoGatheringEarlyConfirmationDialogProps) {
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      isDismissable={!isPending}
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>
          Are you sure you want to connect with a Pro?
        </ModalDialogTitle>
        <ModalDialogDescription>
          Keep in mind that once you connect with your assigned Pro, they'll ask
          you to fill out the information anyway. You can get started now!
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            label="Connect with a Pro"
            variant="outline"
            onPress={onConfirm}
            isPending={isPending}
            testId={confirmTestId}
          />
          <Button
            variant="text"
            label="Close"
            onPress={onClose}
            isDisabled={isPending}
            testId={closeTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
